import { createConfig, createStorage, http } from 'wagmi';
import { goerli, mainnet, polygon, sepolia } from 'wagmi/chains';
import { injected, walletConnect } from 'wagmi/connectors';

import config from '@app/config';

import { walletIds } from './wallet-connect';

const { walletConnectProjectId } = config;

// Wallet Connect
export const walletConnectConnector = walletConnect({
    // As of now, WalletConnect will throw an error when trying to
    // connect using Blocto if more than one chain is selected below
    projectId: walletConnectProjectId,
    showQrModal: true,
    qrModalOptions: {
        enableExplorer: true,
        explorerRecommendedWalletIds: [walletIds.ledger, walletIds.blocto],
        themeMode: 'dark',
        themeVariables: {
            // Overwrites default z-index value so that modal shows on top of WalletSheet
            '--wcm-z-index': '9999',
        },
    },
});

export const metamaskConnector = injected({ target: 'metaMask' });

const connectors = [metamaskConnector, walletConnectConnector];
export const wagmiConfig = createConfig({
    connectors,
    chains: [mainnet, goerli, polygon, sepolia],
    storage: createStorage({ storage: window.localStorage }),
    transports: {
        [mainnet.id]: http(),
        [goerli.id]: http(),
        [sepolia.id]: http(),
        [polygon.id]: http(),
    },
});
